// extracted by mini-css-extract-plugin
export var success = "success-module--success--3OCBr";
export var title = "success-module--title--FFDVy";